let accessToken: string | null = null;
let refreshAccessToken: (() => Promise<string | null>) | null = null;

export const setAccessTokenRefresher = (
  fn: (() => Promise<string | null>) | null,
): void => {
  refreshAccessToken = fn;
};

export const setAccessToken = (token: string | null): void => {
  accessToken = token;
};

export const clearAccessToken = (): void => {
  accessToken = null;
};

export const getAccessTokenSync = (): string | null => accessToken;

/**
 * Ask BeeHive for a fresh token when possible and retain an in-memory fallback.
 * Bearer tokens must not be persisted in localStorage, where any page script
 * can read them and where they survive the session that obtained them.
 */
export const getAccessToken = async (): Promise<string | null> => {
  if (refreshAccessToken) {
    try {
      const token = await refreshAccessToken();
      if (token) {
        accessToken = token;
        return token;
      }
    } catch (error) {
      console.error("Error refreshing access token:", error);
    }
  }
  return accessToken;
};
